var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCaretDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 6,
  viewBox: "0 0 9 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 5.5L0.541668 0.5L8.45833 0.5L4.5 5.5Z",
  fill: "#585864"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCaretDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/caretDown.af016f06cdd5a8dc3ae99b26c72616d4.svg";